import request from "@/util/request";
// 详情
export function getGysjData(id) {
  return request({
    url: "/api/restful/findByIds?id=" + id,
    method: "get"
  });
}
// 规划面积gis
export function getIndexByPositionCode(data) {
  return request({
    url: "/api/restful/getIndexByPositionCode",
    method: "get",
    params: data
  });
}
//实施主体数据获取
export function findOrgCompanyByIsSubjectGetOrgCompany(data) {
  return request({
    url: "/api/restful/findOrgCompanyByIsSubjectGetOrgCompany",
    method: "get",
    params: data
  });
}
//获取园区总投资数据
export function findDataProjectByDataProjectTypeIdNYDP(data) {
  return request({
    url: "/api/restful/findDataProjectByDataProjectTypeIdNYDP",
    method: "get",
    params: data
  });
}
//获取项目总进度数据
export function getDataProjectByCompletionType(data) {
  return request({
    url: "/api/restful/getDataProjectByCompletionType",
    method: "get",
    params: data
  });
}
//联农带农总统计
export function getOrgProcessGetLNDNALL(data) {
  return request({
    url: "/api/restful/getScreenV2GetOrgProcessGetLNDNALL",
    method: "get",
    params: data
  });
}

//所有企业的带动农户
export function getOrgProcessOrgALLDDNH(data) {
  return request({
    url: "/api/restful/getScreenV2GetOrgProcessOrgALLDDNH",
    method: "get",
    params: data
  });
}

//所有企业的带动农户
export function getOrgProcessByOrgIdGetMNSR(data) {
  return request({
    url: "/api/restful/getScreenV2GetOrgProcessByOrgIdGetMNSR",
    method: "get",
    params: data
  });
}
//
export function getLayerByIndexId(data) {
  return request({
    url: "/api/restful/getLayerByIndexId",
    method: "get",
    params: data
  });
}
//实施主体根据id查信息
export function getScreenV2FindOrgCompanyById(data) {
  return request({
    url: "/api/restful/getScreenV2FindOrgCompanyById",
    method: "get",
    params: data
  });
}
//实施主体根据id查指标
export function getScreenV2GetQYZB(data) {
  return request({
    url: "/api/restful/getScreenV2GetQYZB",
    method: "get",
    params: data
  });
}
//建设项目根据id查进度
export function getScreenV2findDataProjectProgressById(data) {
  return request({
    url: "/api/restful/getScreenV2findDataProjectProgressByIdDESC",
    method: "get",
    params: data
  });
}
//根据企业ID查询所有企业品牌
export function findOrgCompanyBrand(data) {
  return request({
    url: "api/restful/findOrgCompanyBrandByCompanyId",
    method: "get",
    params: data
  });
}
//点击企业请求的项目信息（名称和进度）
export function findDataProjectYNQYXMXX(data) {
  return request({
    url: "api/restful/findDataProjectYNQYXMXX",
    method: "get",
    params: data
  });
}
// 点击企业企业荣誉
export function findOrgCompanyHonorByorgOrgCompanyId(data) {
  return request({
    url: "/api/restful/findOrgCompanyHonorByorgOrgCompanyId",
    method: "get",
    params: data
  });
}
export function findDataProjectProgressBydataProjectId(data) {
  return request({
    url: "/api/restful/getScreenV2findDataProjectProgressById",
    method: "get",
    params: data
  });
}
//养殖基地
export function findOrgCompanyPlaceByList(data) {
  return request({
    url: "/api/restful/findOrgCompanyPlaceByList",
    method: "get",
    params: data
  });
}
//气象echart历史数据
export function getScreenV2FindHdDeviceGetLSSJ(data) {
  return request({
    url: "/api/restful/selectSensorData",
    method: "get",
    params: data
  });
}
//气象接口
export function hdDeviceQxDataNow(data) {
  return request({
    url: "/api/restful/hdDeviceQxDataNow",
    method: "get",
    params: data
  });
}
//环境监测根据设备id获取设备实时数据
export function getScreenV2FindSensorDataByCode(data) {
  return request({
    url: "/api/restful/getScreenV2FindSensorDataByCode",
    method: "get",
    params: data
  });
}
//联农带农总统计
export function getOrgProcessGetLNDNALL2(data) {
  return request({
    url: "/api/restful/getScreenV2GetOrgProcessGetLNDNALL2",
    method: "get",
    params: data
  });
}

// 墒情
export function wlwSoilData(data) {
  return request({
    url:
      "http://121.37.201.53:9015/smm/service/api/restful/findWlwSoilDataNowByCodeFirst",
    method: "get",
    params: data
  });
}
